import { render, staticRenderFns } from "./importRecords.vue?vue&type=template&id=37940ff3&scoped=true"
import script from "./importRecords.vue?vue&type=script&lang=js"
export * from "./importRecords.vue?vue&type=script&lang=js"
import style0 from "./importRecords.vue?vue&type=style&index=0&id=37940ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37940ff3",
  null
  
)

export default component.exports